import { createIdentifier } from '@wix/thunderbolt-ioc'

export interface IDomSelectors {
	getByCompId(compId: string, doc?: Document, context?: Record<string, any>): HTMLElement | null
	getClosestByCompId(element: Element, compId: string, context?: Record<string, any>): Element | null
	querySelector(selector: string, doc?: Document, context?: Record<string, any>): Element | null
	querySelectorAll(selector: string, doc?: Document, context?: Record<string, any>): Element[]
	getElementCompId(element: Element, context?: Record<string, any>): string
}

export const DomSelectorsSymbol = createIdentifier<IDomSelectors>(Symbol('DomSelectors'))
